<template>
  <el-dialog class="add-together-popup" :title="step == 1?'新增揪團':'確認資訊'" :visible="showDialog" @close="onClose()" width="600px">
    <div v-if="step == 1">
      <el-form  label-position="left" label-width="100px">
      <el-form-item label="名稱">
            <el-input v-model="formItem.itemTitle" placeholder="請輸入湊團物品名稱"></el-input>
        </el-form-item>
        <el-form-item label="組合">
            <el-select v-model="formItem.groupName" placeholder="请選擇組合">
                <el-option v-for="(member,i) in groups" :label="member"  :value="member" :key="i"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="種類">
            <el-radio-group v-model="formItem.category" placeholder="请選擇組合">
                <el-radio label="官方"  value="官方">官方</el-radio>
                <el-radio label="飯制"  value="飯制">飯制</el-radio>
            </el-radio-group>
        </el-form-item>
         <el-form-item label="描述">
            <el-input v-model="formItem.desc" type="textarea" placeholder="描述"></el-input>
        </el-form-item>
        <!-- <el-upload
            action="https://jsonplaceholder.typicode.com/posts/"
            list-type="picture-card">
        <i class="el-icon-plus"></i>
        </el-upload> -->
        <el-form-item label="截止日期"> 
            <el-date-picker
              v-model="formItem.expired_time"
              type="date"
              placeholder="选择截止日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item>
            <template slot="label">
              <p class="label-text">成團規則
                <el-tooltip effect="dark" content="Top Center 提示文字" placement="top">
                <div slot="content">直接成團：團員提交申請後直接扣除數量<br/>審核成團：提交申請不會扣除數量，團主須至後臺審核成團名單<br/>上帶下：須設置需多帶區/單帶區/多帶比例</div>
                <span class="instruction">?</span>
              </el-tooltip>
              </p>
              
            </template>
            
            
            <el-radio-group v-model="formItem.rule">
                <el-radio v-for="(category,i) in ruleList" :label="category.type"  :value="category.name" :key="i">
                  {{category.name}}
                </el-radio>
            </el-radio-group>
        </el-form-item>
        </el-form>
        <el-form class="item-detail-container">
        <div class="item-group-name"  v-if="formItem.rule == 'C'||formItem.rule == 'D'">多帶區（需帶單帶區）</div>
        <div class="item-detail" v-for="(item,i) in formItem.itemListA" :key="i">
          <el-form-item class="item-detail-item"
          >
            <el-input v-model="item[0]" placeholder="请輸入項目名稱"></el-input>
          </el-form-item>
          <el-form-item class="item-detail-item"
          >
            <el-select v-model="item[1]" placeholder="请選擇數量">
                <el-option v-for="(num,i) in 20" :value="num" :key="i"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="item-detail-item"
          >
            <el-input v-model="item[2]" placeholder="请輸入單項價錢"></el-input>
          </el-form-item>
          <el-button @click="removeItem(i,'A')">刪除</el-button>
       </div>
        <el-button @click="addItem('A')">新增</el-button>
        </el-form>
        <el-form class="item-detail-container"  v-if="formItem.rule == 'C'||formItem.rule == 'D'">
        <div class="item-group-name">單帶區</div>
        <div class="item-detail" v-for="(item,i) in formItem.itemListB" :key="i">
          <el-form-item class="item-detail-item"
          >
            <el-input v-model="item[0]" placeholder="请輸入項目名稱"></el-input>
          </el-form-item>
          <el-form-item class="item-detail-item"
          >
            <el-select v-model="item[1]" placeholder="请選擇數量">
                <el-option v-for="(num,i) in 20" :value="num" :key="i"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="item-detail-item"
          >
            <el-input v-model="item[2]" placeholder="请輸入單項價錢"></el-input>
          </el-form-item>
          <el-button @click="removeItem(i,'B')">刪除</el-button>
       </div>
        <el-button @click="addItem('B')">新增</el-button>
        </el-form>
    
    </div>
     <div class="check-info" v-else>
       <p><span class="form-title">開團物品</span>{{formItem.itemTitle}}</p>
       <p><span class="form-title">組合</span>{{formItem.groupName}}</p>
       <p><span class="form-title">描述</span>{{formItem.desc}}</p>
       <p><span class="form-title">截止日期</span>{{formItem.expired_time}}</p>
       <p><span class="form-title">項目</span></p>
       <div class="item-list">
         <table class="item-list-table">
           <tr>
             <th>項目</th>
             <th>數量</th>
             <th>單價</th>
           </tr>
           <tr v-for="(item,i) in formItem.itemListA" :key="i">
             <td>{{item[0]}}</td>
             <td>{{item[1]}}</td>
             <td>{{item[2]}}</td>
           </tr>
         </table>
       </div>
       <div class="item-list" v-if="formItem.rule == 'C'|| formItem.rule == 'D'">
         <table class="item-list-table">
           <tr>
             <th>項目</th>
             <th>數量</th>
             <th>單價</th>
           </tr>
           <tr v-for="(item,i) in formItem.itemListB" :key="i">
             <td>{{item[0]}}</td>
             <td>{{item[1]}}</td>
             <td>{{item[2]}}</td>
           </tr>
         </table>
       </div>
    </div>
    <div slot="footer" class="dialog-footer">    
              <el-button @click="onClose()">{{step == 1?"關閉":"返回編輯"}}</el-button>
              <el-button type="primary" @click="onSubmit()">{{step == 1?"下一步":"確定送出"}}</el-button>
          </div>
        </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import {createTogetherItem} from '../../../api/together'
export default {
   props: {
        showDialog: {
            type: Boolean,
            require: true
        }
    },
    data(){
      return {
        step: 1,
        // '自動成團（團員提交申請後自動扣除名額）',
          // '多帶優先（不自動扣除名額）',
          // '上帶下（團員提交申請後自動扣除名額）',
          // '上帶下（不自動扣除名額）'
        ruleList:[
          {type:'A',name:'直接成團'},
          {type:'B',name:'審核成團'},
          {type:'C',name:'需多帶並直接成團'},
          {type:'D',name:'需多帶並審核成團'},
        ],
        formItem:{
          itemTitle:"",
          groupName:"",
          category:"",
          desc:"",
          expired_time:"",
          rule:"",
          itemListA:[['',null,null]],
          itemListB:[['',null,null]],
        },
      }
    }, 
    computed:{
        ...mapState({
            groups: state => state.basic.groups,
        }),
        
    },
    watch:{
      showDialog(newValue){
        if (newValue){
          this.step = 1
          this.formItem = {
          title:"",
          groupName:"",
          category:"",
          desc:"",
          expiredDate:"",
          rule:"",
          itemListA:[['',null,null]],
          itemListB:[['',null,null]],
        }
        }
      }
    },
    methods: {
      onClose(){
         if (this.step == 1){
          this.$store.commit('user/hideAddTogether')
        } else {
          this.step =1
        }
        },
        removeItem(index,type) {
          if (type =='A'){
            this.formItem.itemListA.splice(index, 1)
          } else {
            this.formItem.itemListB.splice(index, 1)
          }
          
      },
      onSubmit(){
        if (this.step == 1){
          this.step = 2
        } else {
          let params = this.formItem
          params.creator = this.$store.state.user.userName
          createTogetherItem(params).then(res => {
            if (res.status == 'success') {
                    this.$message.success('成功新增揪團')
                    this.$store.commit('user/hideAddTogether')
                    if (this.$route.path == '/together'){
                        this.$router.push('/reload')
                    } else {
                        this.$router.push('/together')
                    }
            
                }
            }).catch(err => {
                console.log(err);
            });
        }
            
        },
      addItem(val) {
        if (val == 'A'){
          this.formItem.itemListA.push(['',null,null]);
        } else {
          this.formItem.itemListB.push(['',null,null]);
        }
        
        console.log(this.formItem.itemList)
      }
    }

}
</script>

<style lang="scss" scoped>
.add-together-popup {
  /deep/.el-form-item__label{
    background-color: $mainColor;
    text-align: center;
    border-radius: 5px;
    margin-right: 10px;
    padding: 0;
    position: relative;
  }
  /deep/ .el-input,.el-textarea,.el-radio-group {
        width: 90%;
    }
  .item-detail-item{
    margin-bottom: 0px;
  }
  .item-detail-container {
      
      border: 1px solid $mainColor;
      border-radius: 5px;
      padding: 10px;
      margin-top: 20px;
    
    .item-detail{
      display: flex;
      margin-bottom: 20px;
    }
  }
  .instruction{
    position: absolute;
    display: block;
    width: 15px;
    height: 15px;
    border-radius: 8px;
    color: $textColor;
    background-color: #fff;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    line-height: 15px;
  }
   .check-info {
        p {
            margin-bottom: 10px;
        }
        .form-title {
            display: inline-block;
            background-color: $mainColor;
            width: 90px;
            padding: 10px 5px;
            text-align: center;
            border-radius: 5px;
            margin-right: 10px;
        }
        .desc {
            border-radius: 10px;
            border: 1px solid $textColor;
            padding: 20px;
        }
        .item-list{
          border: 1px solid $mainColor;
          padding: 15px;
          border-radius: 10px;
        }
        .item-list-table {
          width: 100%;
          text-align: center;
          th {
            color: $textColor;
            border-bottom: 1px solid $mainColor;
            padding: 10px 0;
          }
          td {
            padding: 10px 0;
          }
        }
    }
}

</style>